
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Database } from '@/integrations/supabase/types';

type Mediator = Database['public']['Tables']['mediators']['Row'];
type MediatorInsert = Database['public']['Tables']['mediators']['Insert'];

export const useMediators = (filters?: {
  mediationArea?: string;
  city?: string;
  availableDay?: string;
}) => {
  return useQuery({
    queryKey: ['mediators', filters],
    queryFn: async () => {
      // Utiliser la vue publique sécurisée
      let query = supabase
        .from('public_mediator_search')
        .select('*');

      if (filters?.city) {
        query = query.eq('city', filters.city);
      }

      if (filters?.mediationArea) {
        query = query.contains('mediation_areas', [filters.mediationArea]);
      }

      if (filters?.availableDay) {
        query = query.contains('available_days', [filters.availableDay]);
      }

      const { data, error } = await query;
      
      if (error) throw error;
      // Reformater pour correspondre à l'ancienne structure
      return data?.map(item => ({
        ...item,
        profiles: {
          full_name: item.full_name,
          city: item.city,
          bio: item.bio
        }
      }));
    },
  });
};

export const useCreateMediator = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (mediator: MediatorInsert) => {
      const { data, error } = await supabase
        .from('mediators')
        .insert(mediator)
        .select()
        .single();
      
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mediators'] });
    },
  });
};
